import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NavHeaderComponent } from './module/navbar/nav-header.component';
import { SidebarComponent } from './module/sidebar/sidebar.component';

import { DashboardModule } from './module/dashboard/dashboard.module';
import { LoginModule } from './module/login/login.module';
import { AddinstoreModule } from './module/addinstore/addinstore.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BulkuploadModule } from './module/bulkupload/bulkupload.module';
import { UsermanagementModule } from './module/usermanagement/usermanagement.module';
import { ConfirmDialogModule } from './module/confirm-dialog/confirm-dialog.module';
import { AddcampaignModule } from './module/addcampaign/addcampaign.module';
import { AddhoardingModule } from './module/addhoarding/addhoarding.module';
import { InstorelistModule } from './module/instorelist/instorelist.module';
import { ProfileModule } from './module/profile/profile.module';
import { PasswordModule } from './module/password/password.module';

import { CampaignlistModule } from './module/campaignlist/campaignlist.module';  

import { ReportModule } from './module/report/report.module'; 
import { CalenderModule } from './module/calender/calender.module'; 
import { HoardinglistModule } from './module/hoardinglist/hoardinglist.module'; 
import { MapModule } from './module/map/map.module'; 
import { BulkcampaignModule } from './module/bulkcampaign/bulkcampaign.module'; 
import { BulkhoardingModule } from './module/bulkhoarding/bulkhoarding.module';
import { AuthGuard } from './_guards/index';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
// used to create fake backend
import { fakeBackendProvider } from './_helpers';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { ChartsModule } from 'ng2-charts';

@NgModule({
  declarations: [
    AppComponent,
    NavHeaderComponent,
    SidebarComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule,
    DashboardModule,
    LoginModule,
    AddinstoreModule,
    FontAwesomeModule,
    BulkuploadModule,
	  UsermanagementModule,
    AddcampaignModule,
    AddhoardingModule,
    InstorelistModule,
    CampaignlistModule,
    ReportModule,
    CalenderModule,
    HoardinglistModule,
    MapModule,
    BulkcampaignModule,ProfileModule,PasswordModule,
    BulkhoardingModule,ConfirmDialogModule, ChartsModule
  ],
  providers: [
     AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    // provider used to create fake backend
    fakeBackendProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
